
import {
	SUBMIT_ORDER_REQUEST,
	SUBMIT_ORDER_SUCCESS,
	SUBMIT_ORDER_FAILURE,
	INITIATE_PAYMENT_REQUEST,
	INITIATE_PAYMENT_SUCCESS,
	INITIATE_PAYMENT_FAILURE
} from './choose-menu-types';

const initialState = {
	submitting: false,
	submitError: null,
	submitSuccess: false,
	orderResponse: null,
	// Payment initiation state
	paymentInitiating: false,
	paymentSuccess: false,
	paymentError: null,
	paymentResponse: null,
};

export default function chooseMenuReducer(state = initialState, action) {
	switch (action.type) {
		case SUBMIT_ORDER_REQUEST:
			return {
				...state,
				submitting: true,
				submitError: null,
				submitSuccess: false
			};
		case SUBMIT_ORDER_SUCCESS:
			return {
				...state,
				submitting: false,
				submitSuccess: true,
				orderResponse: action.payload
			};
		case SUBMIT_ORDER_FAILURE:
			return {
				...state,
				submitting: false,
				submitError: action.payload,
				submitSuccess: false
			};
		case INITIATE_PAYMENT_REQUEST:
			return {
				...state,
				paymentInitiating: true,
				paymentError: null,
				paymentSuccess: false
			};
		case INITIATE_PAYMENT_SUCCESS:
			return {
				...state,
				paymentInitiating: false,
				paymentSuccess: true,
				paymentResponse: action.payload
			};
		case INITIATE_PAYMENT_FAILURE:
			return {
				...state,
				paymentInitiating: false,
				paymentError: action.payload,
				paymentSuccess: false
			};
		default:
			return state;
	}
}
